class Teaser {
  constructor(el,opt){
    this.el = el;
    if($("." + this.el).length > 0){
      this.event();
    }
  }
  event(){
    // const scrollMv = "." + this.el;
    // const trigger = '.js-teaser-mv-trigger';
    // gsap.to(scrollMv,{
    //   scrollTrigger: {
    //     trigger: trigger,
    //     start: "bottom 80%",
    //     toggleActions: 'none none none none',
    //     toggleClass: {targets: scrollMv, className: 'is-active'},
    //   }
    // })
  }
}
